// ── CAPR S4 — ONE EVIDENCE ITEM'S VERDICT, rendered as the server sent it ──────────────────────
//
// ⚠ ONE COMPONENT FOR EVERY SURFACE: the assessor's picker and the approver's view (the live verdict
//   from the Hub) and the decision history (the verdict recorded at approval). They render the SAME
//   status and reasons the SAME way, so the screens cannot describe one item two ways.
//
// ⚠ IT DERIVES NOTHING. The status and the reasons are the server's; this maps their codes to the
//   shared words and nothing more. It never reads a signal to decide anything.

import { cn } from '@/lib/utils';
import type { CtsEvidenceVerificationStatus, CtsUnverifiedReason } from '@grc/shared';
import { UNVERIFIED_LABEL, VERIFIED_LABEL, VERIFICATION_UNAVAILABLE, reasonText } from './assessment-copy';

export function EvidenceVerdict({ status, reasons }: {
  /** null = the verdict could not be read (never shown as either status). */
  status: CtsEvidenceVerificationStatus | null;
  reasons: CtsUnverifiedReason[] | null;
}) {
  if (status === null) {
    return <p className="mt-[5px] text-[11.5px] italic text-text-faint" data-testid="evidence-verdict-unavailable">{VERIFICATION_UNAVAILABLE}</p>;
  }
  const verified = status === 'verified_accepted';
  return (
    <div className="mt-[5px]" data-testid="evidence-verdict" data-status={status}>
      <p className={cn('text-[11.5px] font-medium', verified ? 'text-cert-valid-fg' : 'text-cert-warn-fg')}>
        {verified ? VERIFIED_LABEL : UNVERIFIED_LABEL}
      </p>
      {!verified && reasons && reasons.length > 0 && (
        <ul className="mt-[2px] list-disc pl-[16px] text-[11.5px] text-text-secondary">
          {reasons.map((r) => <li key={r} data-testid="evidence-verdict-reason" data-reason={r}>{reasonText(r)}</li>)}
        </ul>
      )}
    </div>
  );
}
